import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';

import IconButton from "@material-ui/core/IconButton/index";
import Zoom from "@material-ui/core/Zoom/index";
import Tooltip from "@material-ui/core/Tooltip/index";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {CuentaBancariaService} from "../../../../services/_Sis/CuentaBancariaService/CuentaBancariaService";
import ModalCuentaBancaria from "./ModalCuentaBancaria";
import {CONFIG} from "../../../../settings/Config/Config";


class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar la cuenta bancaria del beneficiario: ${item.nombre_beneficiario}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				CuentaBancariaService.Eliminar(item.id_cuenta_bancaria).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	render() {
		
		const {lista} = this.props;
		
		return (
			<Paper style={{overflowX: "auto"}}>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							{/*<TableCell component="th" align={'left'}>Id</TableCell>*/}
							<TableCell component="th" align={'left'} className={'padding-20-L padding-20-R'}>Beneficiario</TableCell>
							<TableCell component="th" align={'left'}>A quien se le paga</TableCell>
							{/*<TableCell component="th" align={'left'}>Nombre Comercial</TableCell>*/}
							<TableCell component="th" align={'left'}>RFC</TableCell>
							<TableCell component="th" align={'left'}>Banco</TableCell>
							<TableCell component="th" align={'left'}>No. Cuenta</TableCell>
							<TableCell component="th" align={'left'}>No. Tarjeta</TableCell>
							<TableCell component="th" align={'left'}>Clabe</TableCell>
							<TableCell component="th" align={'left'}>Activo</TableCell>
							<TableCell component="th" align={'center'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								{/*<TableCell align={'center'}>{item.id_cuenta_bancaria}</TableCell>*/}
								<TableCell align={'left'} className={'padding-20-L padding-20-R'}>{item.nombre_razon_social}</TableCell>
								<TableCell align={'left'}>{item.nombre_recibe_pago}</TableCell>
								{/*<TableCell align={'left'}>{item.nombre_comercial}</TableCell>*/}
								<TableCell align={'left'}>{item.rfc}</TableCell>
								<TableCell align={'left'}>{item.banco}</TableCell>
								<TableCell align={'left'}>{item.numero_cuenta}</TableCell>
								<TableCell align={'left'}>{item.numero_tarjeta}</TableCell>
								<TableCell align={'left'}>{item.clabe}</TableCell>
								<TableCell align={'center'}>
									{Number(item.activo) === 1 ? (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "darkgreen",
											display: "inline-grid",
										}}>Activo</div>
									) : (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "#901C30",
											display: "inline-grid",
										}}>Inactivo</div>
									)}
								</TableCell>
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									<div className={'w-auto vertical-inline'}>
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
												<IconButton aria-label="Eliminar" onClick={() => this.eliminar(item)}>
													<DeleteOutlined/>
												</IconButton>
											</Tooltip>
										</div>
										<div className={'v-center'}>
											<ModalCuentaBancaria
												tipo={'edit'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
												ListProveedor={this.props.ListProveedor}
												ListBanco={this.props.ListBanco}
												ListAreaProyecto={this.props.ListAreaProyecto}
											/>
										</div>
										<div className={'v-center'}>
											<ModalCuentaBancaria
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
												ListProveedor={this.props.ListProveedor}
												ListBanco={this.props.ListBanco}
												ListAreaProyecto={this.props.ListAreaProyecto}
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
	ListProveedor: PropTypes.func.isRequired,
	ListBanco: PropTypes.func.isRequired,
	ListAreaProyecto: PropTypes.func.isRequired,
};

export default ListaTabla;
